import * as api from '../../api/storefront'
import { adaptProducts, adaptProduct } from '../../adapters/productAdapter'
import { adaptCategories } from '../../adapters/categoryAdapter'
import { adaptBanners } from '../../adapters/bannerAdapter'
import { adaptSellers } from '../../adapters/sellerAdapter'

const list = payload => payload?.data?.pageList || payload?.data?.result || payload?.data || []

export default {
  namespaced: true,
  state: {
    banners: [], categories: [], products: [], newProducts: [], featured: [], flashDeals: [],
    sellers: [], detail: null, loading: false, error: '', pageInfo: {},
    filters: { keyword: '', categoryId: '', sort: '', minPrice: '', maxPrice: '' }, page: 1
  },
  mutations: {
    SET (state, { key, value }) { state[key] = value }
  },
  actions: {
    async home ({ commit }) {
      commit('SET', { key: 'loading', value: true })
      commit('SET', { key: 'error', value: '' })
      try {
        const [home, categories, featured, newest, sellers] = await Promise.allSettled([
          api.fetchHome(), api.fetchCategories(),
          api.fetchProducts({ recTime: 1, pageSize: 10 }),
          api.fetchProducts({ newTime: 1, pageSize: 10 }), api.fetchSellers()
        ])
        const homeData = home.value?.data || {}
        commit('SET', { key: 'banners', value: adaptBanners(homeData.banner || []) })
        commit('SET', { key: 'categories', value: adaptCategories(list(categories.value)) })
        commit('SET', { key: 'featured', value: adaptProducts(list(featured.value)) })
        commit('SET', { key: 'newProducts', value: adaptProducts(list(newest.value)) })
        commit('SET', { key: 'sellers', value: adaptSellers(list(sellers.value)) })
      } catch (error) {
        commit('SET', { key: 'error', value: error.message })
      } finally {
        commit('SET', { key: 'loading', value: false })
      }
    },
    async products ({ commit }, params = {}) {
      commit('SET', { key: 'loading', value: true })
      commit('SET', { key: 'error', value: '' })
      try {
        const response = params.keyword ? await api.searchProducts(params) : await api.fetchProducts(params)
        commit('SET', { key: 'products', value: adaptProducts(list(response)) })
        commit('SET', { key: 'pageInfo', value: response?.data?.pageInfo || {} })
      } catch (error) {
        commit('SET', { key: 'error', value: error.message })
      } finally {
        commit('SET', { key: 'loading', value: false })
      }
    },
    async detail ({ commit }, id) {
      commit('SET', { key: 'loading', value: true })
      commit('SET', { key: 'error', value: '' })
      try {
        const response = await api.fetchProduct(id)
        const product=adaptProduct(response.data)
        const quotes=await Promise.all(product.skus.map(s=>api.fetchFlashQuote(product.id,s.id)))
        product.skus=product.skus.map((s,i)=>({...s,price:Number(quotes[i].data.price),oldPrice:Number(quotes[i].data.basePrice),flashActive:quotes[i].data.flashActive}))
        if(product.skus.length){product.price=product.skus[0].price;product.oldPrice=product.skus[0].oldPrice}else{const q=await api.fetchFlashQuote(product.id,'-1');product.price=Number(q.data.price);product.oldPrice=Number(q.data.basePrice)}
        commit('SET', { key: 'detail', value: product })
      } catch (error) {
        commit('SET', { key: 'error', value: error.message })
      } finally {
        commit('SET', { key: 'loading', value: false })
      }
    },
    async flashDeals ({ commit }) {
      commit('SET', { key: 'loading', value: true })
      commit('SET', { key: 'error', value: '' })
      try {
        const response = await api.fetchFlashDeals()
        const deals = Array.isArray(response.data) ? response.data : []
        commit('SET', { key: 'flashDeals', value: deals.map(deal => ({ ...deal, products: adaptProducts(deal.products || []).map(p=>({...p,flashDealId:deal.id})) })) })
      } catch (error) {
        commit('SET', { key: 'error', value: error.message })
      } finally {
        commit('SET', { key: 'loading', value: false })
      }
    }
  }
}
